import React from "react";
import { Empty, Spin } from "antd";
import { ModalProps } from "antd/lib/modal/Modal";
import { exercisePublishResume, ExerciseStatus } from "service/exercise";
import useRequest from "utils/useRequest";
import BriefInfo from "../../../BriefInfo";
import styles from "./index.module.scss";

interface ViewLogModalProps extends ModalProps {
    id: number;
}

export default function ViewLog({ id }: ViewLogModalProps) {
    const [data, { loading }] = useRequest(() => exercisePublishResume(id));

    return (
        <Spin spinning={loading}>
            {data?.map(item => (
                <div key={item.startTime} className={styles.item}>
                    <BriefInfo item={item} status={ExerciseStatus.done} />
                </div>
            ))}

            {data?.length === 0 && <Empty description="没有发布履历" />}
        </Spin>
    );
}
